<template>
  <div class="progress">
    <div :class="`progress-bar ${ getClassColor() }`"
      role="progressbar"
      :aria-valuenow="currentValue"
      aria-valuemin="0"
      aria-valuemax="100"
      ref="progress"
      :style="`width: ${currentValue}%`">
      {{ currentValue }}%
    </div>
  </div>
</template>

<style lang="scss">
  .progress {
    & .green {
      background-color: #1BB05E;
    }

    & .yellow {
      background-color: #F7A01B;
    }

    & .red {
      background-color: #BD3834;
    }

    & .purple {
      background-color: #BD4BAE;
    }

    .progressbar {
      border: 1px solid #bfbfbf;
      height: 1.5rem;
    }
  }
</style>


<script>
  export default {
    name: 'card',

    props: {
      total: {
        type: Number,
        required: true,
      },

      current: {
        type: Number,
        required: true,
      },
    },

    computed: {
      currentValue() {
        const value = (this.current * 100)/this.total;
        return value.toFixed();
      }
    },

    methods: {
      getClassColor() {
        if (this.currentValue <= 110 && this.currentValue >= 90) {
          return 'green';
        }

        return this.currentValue < 90 && this.currentValue >= 80 ? 'yellow' : 'red';
      },
    },
  }
  </script>
